import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAppSelector } from '@redux/hooks';
import { useCallback } from 'react';
import type { Category } from 'types/redux';

export type TrackingActions =
	| 'save selected filters'
	| 'clear selected filters';

export interface Payload<T extends TrackingActions> {
	min: number;
	max: number;
	action: T;
	category: Category;
	sourcePage?: string;
}

const generatePayload = ({
	action,
	min,
	max,
	category,
	sourcePage,
}: Payload<TrackingActions>) => {
	const categoryCode = category.code;
	return {
		event: 'Filter Vendors',
		properties: {
			action,
			starting_price_min: min,
			starting_price_max: max,
			vendorCategoryCode: categoryCode,
			...(sourcePage && { sourcePage }),
		},
	};
};

export const useTrackSlider = () => {
	const { track } = useAnalyticsContext();
	const category: Category = useAppSelector((state) => state.category);

	return useCallback(
		({ min, max, action, sourcePage }: Payload<TrackingActions>) => {
			const payload = generatePayload({
				min,
				max,
				action,
				category,
				sourcePage,
			});
			return track(payload);
		},
		[track, category],
	);
};
